<mat-card
    [ngClass]="{
        'ui-shadow-box ui-shadow-2': isStandaloneForm,
        'card card-w-title': !isStandaloneForm,
        'd-none': !display
    }"
    *ngIf="panelId !== 'account-performance-overview' && panelId !== 'top-holdings-panel'"
>
    <mat-accordion>
        <mat-expansion-panel
            id="print-preview-expansion-panel"
            [hideToggle]="!enableToggling"
            [expanded]="!collapse"
            [class.sb-panel-no-divider]="divider === false"
            [class.sb-panel-no-header]="hidePanelHeader"
            [disabled]="!collapse"
        >
            <mat-expansion-panel-header class="panel-header">
                <mat-panel-title class="panel-header-title">
                    <mat-card-header>
                        <div class="sb-panel-header" style="width: 100%">
                            <div class="sb-panel-title">{{ title }}</div>
                            <div
                                *ngIf="showPrintPreview$ | async"
                                class="sb-header-toolbar"
                            >
                                <button
                                    class="btn link text-primary"
                                    (click)="btnPrint($event)"
                                >
                                    <tabler-icon
                                        name="printer"
                                        class="me-2"
                                    ></tabler-icon>
                                    Print preview
                                </button>
                            </div>
                            <div *ngIf="isStandaloneForm" class="sb-header-toolbar">
                                <button
                                    mat-icon-button
                                    class="sb-panel-header-button"
                                    matTooltip="Cancel"
                                    (click)="formCancel($event)"
                                >
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-card-header>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row gy-3" style="position: relative">
                <ng-template appSbPanel></ng-template>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</mat-card>
<ng-container *ngIf="panelId === 'account-performance-overview'">
    <sb-temp-performance class="mt-4 d-block"></sb-temp-performance>
</ng-container>
